import { PageWrapper } from "../../components/page-skeleton/PageWrapper";
import { CardContainer } from "../../components/page-skeleton/CardContainer";
import { PageHeader } from "../../components/page-skeleton/PageHeader";
import { useSelector } from "react-redux";
import * as authSelectors from "../../module/auth/authSelectors";
import { useGetMenuCampaigns } from "./service/menus-api";
import { Outlet, useParams } from "react-router-dom";
import { MenuCampaignsTable } from "./components/MenuCampaignsTable";
import { SpinnerBlock } from "../common/Spinner";
import { EmptyState } from "../../components/EmptyState";
import { Divider } from "../../components/Divider";
import { ButtonInternalLink } from "../../components/NewButtons";
import { routes } from "../../appRoutingHelpers";

export const MenuCampaigns = () => {
  const { id } = useParams<{
    id: string;
  }>();
  const organizationKeyName = useSelector(
    authSelectors.selectedOrganizationKeyName
  );
  const { data: campaigns, isLoading } = useGetMenuCampaigns(
    organizationKeyName,
    id
  );

  if (isLoading) {
    return <SpinnerBlock />;
  }

  return (
    <>
      <PageWrapper>
        <CardContainer>
          <PageHeader
            title="Auto campaigns"
            subtitle="Manage all of your auto campaigns on this menu"
          >
            <ButtonInternalLink
              to={routes.menuEditCampaignsAdd(organizationKeyName, id)}
            >
              Add campaign to menu
            </ButtonInternalLink>
          </PageHeader>
          {!campaigns || campaigns.length === 0 ? (
            <>
              <Divider />
              <EmptyState
                title="No campaigns found"
                subtitle="Add a campaign to this menu"
              />
            </>
          ) : (
            <MenuCampaignsTable campaigns={campaigns} />
          )}
        </CardContainer>
      </PageWrapper>
      <Outlet />
    </>
  );
};
